import BotaoModelo from "../BotaoModelo";

export function BotaoFaleConosco({ $grow }) {
  return (
    <BotaoModelo
      $backgroundcolor={"#88bd28"}
      texto={"Fale Conosco"}
      temIcone={"true"}
      $grow={$grow}
      hrefUrl={"https://api.whatsapp.com/send?l=pt_br&phone=551731228600"}
      customOnClick={(url) => {
        window.open(url);
      }}
    />
  );
}

export function BotaoEnviar() {
  return (
    <BotaoModelo
      texto={"Enviar"}
      $backgroundcolor={"#88bd28"}
      $width={"fit-content"}
      $alignself={"center"}
      type={"submit"}
    />
  );
}

export function BotaoAreaCliente() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Área do cliente"}
      hrefUrl={"https://cliente.waybe.com.br/login"}
      customOnClick={(url) => {
        window.open(url);
      }}
    />
  );
}

export function BotaoSejaParceiro() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Seja um parceiro"}
      hrefUrl={null}
      customOnClick={() => {
        const SecaoPagina = document.getElementById("formParceiro");
        if (SecaoPagina) {
          SecaoPagina.scrollIntoView({ behavior: "smooth" });
        }
      }}
    />
  );
}

export function BotaoEnviarMensagem() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Enviar mensagem"}
      hrefUrl={null}
      customOnClick={() => {
        const SecaoPagina = document.getElementById("formFale");
        if (SecaoPagina) {
          SecaoPagina.scrollIntoView({ behavior: "smooth" });
        }
      }}
    />
  );
}

export function BotaoQueroSerParceiro() {
  return (
    <BotaoModelo
      $backgroundcolor={"white"}
      color={"#1B355E"}
      texto={"Quero ser um parceiro Sifat"}
      $width={"fit-content"}
      $alignself={"center"}
      $padding={"2em 2em"}
      $bigradius={"var(--border-radius-l)"}
      customOnClick={() => {
        const SecaoPagina = document.getElementById("formParceiro");
        if (SecaoPagina) {
          SecaoPagina.scrollIntoView({ behavior: "smooth" });
        }
      }}
      hrefUrl={null}
    />
  );
}

export function BotaoReceberLigacao() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Receber ligação"}
      customOnClick={() => {
        const SecaoPagina = document.getElementById("formLigacao");
        if (SecaoPagina) {
          SecaoPagina.scrollIntoView({ behavior: "smooth" });
        }
      }}
      hrefUrl={null}
    />
  );
}

export function BotaoTesteGratisWaychef() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Teste grátis"}
      hrefUrl={
        "https://erp.waychef.com.br/publico/cadastro_empresa_integrador.xhtml?integrador=2"
      }
      customOnClick={(url) => {
        window.open(url);
      }}
    />
  );
}

export function BotaoTesteGratisWaychefPequeno() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Teste grátis"}
      hrefUrl={
        "https://erp.waychef.com.br/publico/cadastro_empresa_integrador.xhtml?integrador=2"
      }
      $padding={"1.5em 0.8em"}
      customOnClick={(url) => {
        window.open(url);
      }}
    />
  );
}

export function BotaoUseGratisWaychef() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Use grátis"}
      hrefUrl={
        "https://erp.waychef.com.br/publico/cadastro_empresa_integrador.xhtml?integrador=2"
      }
      customOnClick={(url) => {
        window.open(url);
      }}
    />
  );
}

export function BotaoUseGratisWaychefPequeno() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Use grátis"}
      $padding={"1.5em 0.8em"}
      hrefUrl={
        "https://erp.waychef.com.br/publico/cadastro_empresa_integrador.xhtml?integrador=2"
      }
      customOnClick={(url) => {
        window.open(url);
      }}
    />
  );
}

export function BotaoInscrevaWaymenu() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Inscreva-se"}
      hrefUrl={"https://erp.waybe.com.br/cadastro/2"}
      customOnClick={(url) => {
        window.open(url);
      }}
    />
  );
}

export function BotaoPlanosPrecos() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Planos e Preços"}
      hrefUrl={null}
      customOnClick={() => {
        const SecaoPagina = document.getElementById("tabela-precos");
        if (SecaoPagina) {
          SecaoPagina.scrollIntoView({ behavior: "smooth" });
        }
      }}
    />
  );
}

export function BotaoEnviarCurriculo() {
  return (
    <BotaoModelo
      $backgroundcolor={"#1B5EA4"}
      texto={"Enviar currículo"}
      $width={"fit-content"}
      $alignself={"center"}
      hrefUrl={null}
      customOnClick={() => {
        const SecaoPagina = document.getElementById("formTrabalhe");
        if (SecaoPagina) {
          SecaoPagina.scrollIntoView({ behavior: "smooth" });
        }
      }}
    />
  );
}
